import React from "react";

import { Styles, withStyles } from "./styles";

const BaseContainer: React.FC<Styles> = ({ children, classes }) => (
  <div className={classes.container}>{children}</div>
);

export const Container = withStyles(BaseContainer);
